import { render, staticRenderFns } from "./EditPart.vue?vue&type=template&id=61b80912&"
import script from "./EditPart.vue?vue&type=script&lang=js&"
export * from "./EditPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports